import React, { Fragment } from 'react';
import { number, string, func, instanceOf } from 'prop-types';
import { connect } from 'react-redux';

import SurveyNameForm from '../SurveyNameForm';
import CategorySelection from './CategorySelection';
import StudySelection from './StudySelection';
import {
  clearTargettingCriteria,
  resetState,
  getIEInitialData,
  updateExpressions,
  handleCreateSurvey,
} from '../../../actions/turnkeyOmnibusActions';

const SurveySettings = ({
  handleNext,
  surveyName,
  categoryId,
  study,
  tcSti,
  clearTargettingCriteria,
  resetState,
  activeAccountId,
  getIEInitialData,
  selectedTargets,
  updateExpressions,
  handleCreateSurvey,
  savingSurvey,
}) => {
  const validate = a => {
    const re = /^[a-zA-Z0-9 ]*$/;
    return re.test(a);
  };

  const _isButtonEnable = () => {
    const isValid = validate(surveyName.trim());
    const isDisaled = surveyName && isValid && categoryId && study.pn;
    return !isDisaled || savingSurvey.loading;
  };

  const _hanldeNextclick = () => {
    handleCreateSurvey().then(res => {
      if (res) {
        if (tcSti && study.sti !== tcSti) {
          clearTargettingCriteria().then(res => {
            if (res) {
              handleNext();
            }
          });
        } else {
          if (selectedTargets.length > 0) {
            updateExpressions(selectedTargets);
          }
          handleNext();
        }
      }
    });
  };

  const _handleBackClick = () => {
    resetState();
    getIEInitialData(activeAccountId);
  };

  return (
    <Fragment>
      <div className="ie--steps--body ie--settings">
        <SurveyNameForm />
        <StudySelection />
        {study.sti && <CategorySelection />}
      </div>
      <footer className="ie--steps--footer">
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={_handleBackClick}
        >
          Back
        </button>
        <button
          type="button"
          className="ie--button ie--button-sm"
          onClick={_hanldeNextclick}
          disabled={_isButtonEnable()}
        >
          Save &amp; Continue
        </button>
      </footer>
    </Fragment>
  );
};

SurveySettings.propTypes = {
  handleNext: func.isRequired,
  resetState: func.isRequired,
  clearTargettingCriteria: func.isRequired,
  surveyName: string,
  categoryId: number,
  study: instanceOf(Object),
  tcSti: number,
  getIEInitialData: func,
  activeAccountId: number,
  selectedTargets: instanceOf(Array),
  updateExpressions: func.isRequired,
  handleCreateSurvey: func.isRequired,
  savingSurvey: instanceOf(Object),
};

SurveySettings.defaultProps = {
  categoryId: null,
  study: {
    pn: null,
    sti: null,
  },
  tcSti: null,
  selectedTargets: [],
  savingSurvey: {
    loading: false,
    error: false,
  },
};

const isCategoryValid = (categoryId, ieCategories) => {
  const isValidId = ieCategories.find(item => item.id === categoryId);
  if (isValidId) {
    return categoryId;
  }
  return null;
};

const mapStateToProps = ({ turnkeyOmnibus, account }) => {
  const {
    surveyInfo,
    targetingCriteria,
    selectedTargets,
    savingSurvey,
    ieCategories,
  } = turnkeyOmnibus;
  return {
    surveyName: surveyInfo.surveyName,
    categoryId: isCategoryValid(surveyInfo.categoryId, ieCategories.data),
    selectedTargets,
    study: surveyInfo.study,
    tcSti: targetingCriteria.sti,
    activeAccountId: account.activeAccountId,
    savingSurvey,
  };
};

export default connect(
  mapStateToProps,
  {
    clearTargettingCriteria,
    resetState,
    getIEInitialData,
    updateExpressions,
    handleCreateSurvey,
  }
)(SurveySettings);
